import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type ProductQuickViewProps = {
  features: string[];
  productName: string;
};

export function ProductQuickView({ features, productName }: ProductQuickViewProps) {
  if (!features || features.length === 0) return null;

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="pointer-events-auto w-8 h-8 rounded-full bg-emerald-400/20 backdrop-blur-sm border border-emerald-300/40 flex items-center justify-center text-emerald-300 hover:bg-emerald-400/30 hover:scale-110 transition-all duration-200 touch-manipulation opacity-0 group-hover:opacity-100 group-focus-within:opacity-100"
            aria-label={`Quick view features for ${productName}`}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <Info className="h-4 w-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          align="center"
          className="max-w-[260px] bg-slate-900/98 backdrop-blur-xl border border-emerald-300/30 text-slate-100 shadow-[0_12px_40px_rgba(0,0,0,0.5)] p-4"
          sideOffset={12}
          alignOffset={0}
          collisionPadding={20}
          avoidCollisions={true}
        >
          <div className="space-y-2">
            <h4 className="font-semibold text-emerald-300 text-sm flex items-center gap-2 mb-3">
              <span className="text-base">✨</span>
              Key Features
            </h4>
            <ul className="space-y-2">
              {features.map((feature, index) => (
                <li
                  key={index}
                  className="text-xs text-slate-300 flex items-start gap-2 leading-relaxed"
                >
                  <span className="text-emerald-400 mt-0.5 flex-shrink-0">•</span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
